"use strict";
exports.__esModule = true;
exports.SEGMENT_HEIGHT = void 0;
var tslib_1 = require("tslib");
var Image_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/Image"));
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var polished_1 = require("polished");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utilities_2 = require("../MatchesList/utilities");
exports.SEGMENT_HEIGHT = 60;
var SegmentMatchesWrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  .active {\n    background: ", ";\n    color: ", ";\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  .active {\n    background: ", ";\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.primary;
}, function (_a) {
    var theme = _a.theme;
    return utilities_1.emphasizeColor(1, theme.color.primary);
});
var SegmentRow = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  font-size: ", ";\n  align-items: center;\n  padding: 0 ", ";\n  height: ", ";\n"], ["\n  display: flex;\n  justify-content: space-between;\n  font-size: ", ";\n  align-items: center;\n  padding: 0 ", ";\n  height: ", ";\n"])), polished_1.rem(11), polished_1.rem(8), polished_1.rem(exports.SEGMENT_HEIGHT / 2));
var MatchesResults = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  align-items: center;\n  display: flex;\n  font-weight: bold;\n  & > div {\n    padding: ", ";\n  }\n  a {\n    color: inherit;\n  }\n"], ["\n  align-items: center;\n  display: flex;\n  font-weight: bold;\n  & > div {\n    padding: ", ";\n  }\n  a {\n    color: inherit;\n  }\n"])), "0 " + polished_1.rem(3));
var SegmentTeam = styled_components_1["default"].div(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  width: ", ";\n  img {\n    min-width: ", ";\n    margin-right: ", ";\n  }\n"], ["\n  display: flex;\n  width: ", ";\n  img {\n    min-width: ", ";\n    margin-right: ", ";\n  }\n"])), polished_1.rem(exports.SEGMENT_HEIGHT * 4 - 65), polished_1.rem(15), polished_1.rem(10));
var SegmentTeamName = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"], ["\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n"])));
var SegmentMatches = function (_a) {
    var segmentMatches = _a.segmentMatches, homeTeam = _a.homeTeam, awayTeam = _a.awayTeam;
    var onClubMouseOver = function (clubId) {
        return Array.from(document.getElementsByClassName(clubId)).forEach(function (c) {
            return c.classList.add('active');
        });
    };
    var onClubMouseOut = function (clubId) {
        return Array.from(document.getElementsByClassName(clubId)).forEach(function (c) {
            return c.classList.remove('active');
        });
    };
    var renderSegmentRow = function (team, opposingTeam) {
        return (React.createElement(SegmentRow, { onMouseOver: function () { return team && onClubMouseOver("club_" + team._id); }, onMouseOut: function () { return team && onClubMouseOut("club_" + team._id); }, className: team && "club_" + team._id },
            React.createElement(SegmentTeam, null,
                React.createElement(Image_1["default"], { alt: team && team.displayName, src: (team && utilities_2.getPpoLogoSrc({ _id: team.appSpace })) || '', width: 15, height: 15 }),
                React.createElement(SegmentTeamName, null, team && team.displayName)),
            React.createElement(MatchesResults, null, segmentMatches.map(function (m) {
                var teamGoals = m.protocol &&
                    (m.protocol.events || []).reduce(function (acc, e) {
                        if (team &&
                            e.team === team._id &&
                            e.eventType === 'goal' &&
                            e.type !== 'dropped' &&
                            e.type !== 'goal_shootout') {
                            return acc + 1;
                        }
                        else if (opposingTeam &&
                            e.team === opposingTeam._id &&
                            e.eventType === 'goal' &&
                            e.type === 'dropped' &&
                            e.type !== 'goal_shootout') {
                            return acc + 1;
                        }
                        return acc;
                    }, 0);
                var teamPenaltyGoals = m.protocol &&
                    (m.protocol.events || []).reduce(function (acc, e) {
                        if (team &&
                            e.team === team._id &&
                            e.eventType === 'goal' &&
                            e.type === 'goal_shootout') {
                            return acc + 1;
                        }
                        return acc;
                    }, 0);
                var opposingTeamPenaltyGoals = m.protocol &&
                    (m.protocol.events || []).reduce(function (acc, e) {
                        if (opposingTeam &&
                            e.team === opposingTeam._id &&
                            e.eventType === 'goal' &&
                            e.type === 'goal_shootout') {
                            return acc + 1;
                        }
                        return acc;
                    }, 0);
                if ((teamPenaltyGoals || 0) > (opposingTeamPenaltyGoals || 0)) {
                    teamGoals = (teamGoals || 0) + 1;
                }
                return React.createElement("div", { key: m._id }, teamGoals);
            }))));
    };
    return (React.createElement(SegmentMatchesWrapper, null,
        renderSegmentRow(homeTeam, awayTeam),
        renderSegmentRow(awayTeam, homeTeam)));
};
exports["default"] = SegmentMatches;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
